import * as React from 'react'
import styled, { withTheme } from 'styled-components'
import { mckIdDefaultTheme } from '../themes'

const HeaderWrapper = styled.div`
  .header {
    padding: 0.75rem;
    max-height: 64px;
    background: ${(props) => props.theme.headerBackgroundColor};
  }

  .header__logoWrapper {
    display: flex;
    justify-content: space-between;

    ${(props) => props.theme.desktopBreakpoint} {
      padding: 0.25rem;
    }
  }
  .header__logo {
    max-width: 80px;
    max-height: 35px;
    margin: 0;

    ${(props) => props.theme.desktopBreakpoint} {
      display: inline-block;
      max-width: 104px;
      min-height: auto;
      margin: 0;
      objet-fit: cover;
      width: auto;
    }
  }
`

const Img = styled.img`
  width: 100%;
  margin: 0 auto;
  display: block;
`

const classes = {
  header: 'header',
  logoWrapper: 'header__logoWrapper',
  logo: 'header__logo',
}

type HeaderProps = {
  theme: typeof mckIdDefaultTheme
  logoAltText: string
  bannerLogoUrl?: string
  secondBannerLogoUrl?: string
  bannerBackgroundColor?: string
}

const defaultMcKinseyLogo = 'https://cdn.mckinsey.id/l/logout/mck-logo.png'

function Header({ theme, bannerLogoUrl, secondBannerLogoUrl, bannerBackgroundColor, logoAltText }: HeaderProps) {
  return (
    <HeaderWrapper theme={theme}>
      <header className={classes.header} style={{ backgroundColor: bannerBackgroundColor || undefined }}>
        <section className={classes.logoWrapper}>
          <Img src={bannerLogoUrl || defaultMcKinseyLogo} alt={logoAltText} className={classes.logo} />
          {!!secondBannerLogoUrl && <Img src={secondBannerLogoUrl} alt={logoAltText} className={classes.logo} />}
        </section>
      </header>
    </HeaderWrapper>
  )
}

Header.defaultProps = {
  logoAltText: 'McKID Logo',
}

export default withTheme(Header)
